import { useCallback, useRef } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import { ChatPanel } from './components/ChatPanel';
import { useAiCopilot } from './context/use-ai-copilot';
import { copilotResizeHandle, drawerPaper } from './styles';

export const AiCopilotDrawer: React.FC = () => {
  const { isOpen, drawerWidth, setDrawerWidth } = useAiCopilot();
  const isDragging = useRef(false);

  const handleMouseDown = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      isDragging.current = true;
      document.body.style.userSelect = 'none';
      document.body.style.cursor = 'ew-resize';

      const onMouseMove = (moveEvent: MouseEvent) => {
        const newWidth = window.innerWidth - moveEvent.clientX;
        setDrawerWidth(newWidth);
      };

      const onMouseUp = () => {
        isDragging.current = false;
        document.body.style.userSelect = '';
        document.body.style.cursor = '';
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      };

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    },
    [setDrawerWidth],
  );

  return (
    <Drawer
      data-vy="ai-copilot-drawer"
      variant="persistent"
      anchor="right"
      open={isOpen}
      slotProps={{ paper: { sx: { ...drawerPaper, width: drawerWidth } } }}
    >
      <Box sx={copilotResizeHandle} onMouseDown={handleMouseDown} />
      <ChatPanel />
    </Drawer>
  );
};
